<template>
  <div class="basic-layout">
    <BasicHeaderVue />
    <div class="basic-container">
      <BasicAsideVue />
      <router-view class="basic-main" />
    </div>
    <DialogSignInVue />
    <DialogCustomerServiceVue />
  </div>
</template>

<script>
import BasicHeaderVue from "./basic-header/index.vue";
import BasicAsideVue from "./basic-aside/index.vue";
import DialogSignInVue from "./dialog-sign-in/index.vue";
import DialogCustomerServiceVue from "./dialog-customer-service/index.vue";
import { mapMutations } from "vuex";
import apiUser from "@/api/user.js";

export default {
  name: "BasicLayout",
  components: {
    BasicHeaderVue,
    BasicAsideVue,
    DialogSignInVue,
    DialogCustomerServiceVue,
  },
  methods: {
    ...mapMutations(["setSignInURL"]),

    // 获取微信登录二维码地址接口
    async fetchWeChatQRCode() {
      return await apiUser.fetchWeChatQRCode().catch((error) => {
        console.error("fetchWeChatQRCode");
        throw error;
      });
    },

    // 获取微信登录二维码地址接口操作
    async handleFetchWeChatQRCode() {
      const {
        Success,
        Report: { Wechat, MpWechat },
      } = await this.fetchWeChatQRCode().catch((error) => {
        console.error("handleFetchWeChatQRCode");
        throw error;
      });
      if (!Success) {
        return;
      }
      const signInURL = Wechat ? Wechat.LoginURL : MpWechat.LoginURL;
      this.setSignInURL(signInURL || "");
    },
  },
  async created() {
    await this.handleFetchWeChatQRCode().catch((error) => {
      console.error("created");
      throw error;
    });
  },
};
</script>

<style lang="scss" scoped>
.basic-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  .basic-container {
    display: flex;
    justify-content: space-between;
    height: calc(var(--vh, 1vh) * 100 - var(--header-height));

    .basic-main {
      flex: 1;
    }
  }
}
</style>